import {useEffect, useState} from "react";
import {PAGE_TITLES} from "../scripts/constants";

export default function PageTitle(props) {
  
  let {page,children} = props;
  
  useEffect(() => {
    document.title =  PAGE_TITLES[page] || children;
  },[page]);
  
  return (<></>);
}